import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const anonymousSelector = ({ anonymous }: ReducerState) => anonymous;
export const anonymousLoadingSelector = createSelector(
  anonymousSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
